import { createInitials } from 'global/common/dataAdjust';
import _ from 'lodash';
import { useMatchResults } from 'projectSpecific/sports/useHelpers/useMatchResults';
import { useMemo } from 'react';

const MatchRealtimeScores = ({ match_true, matchResultSourceType }) => {

  const _umr = useMatchResults({ match_true })
  const { result_realtime, result_matchDay } = _umr

  console.log('_umr', matchResultSourceType, _umr)

  const scoreLine = (m) => {
    const { results, displayName } = m ?? {}
    const { score, scores, setNumber } = results ?? {}

    const currentSets = _.pickBy(
      _.omit(scores, 'setNumber'),
      (value, key) => _.startsWith(key, 'set') && _.isObject(value)
    )

    const sets = _.reduce(
      _.omit(scores, 'setNumber'),
      (result, score) => {
        if (score.home > score.away) result.home++
        if (score.away > score.home) result.away++
        return result
      },
      { home: 0, away: 0 }
    )

    const div_match = () => {
      return <div className={'mrl-match'}>
        <div className={score?.away > score?.home ? 'tsw' : ''}>{score?.away}</div>
        <div>-</div>
        <div className={score?.home > score?.away ? 'tsw' : ''}>{score?.home}</div>
      </div>
    }

    const div_sets = (_sets) => {
      const sss = _.map(_sets, (setScore, setKey) => {
        const _setNumber = setKey.replace('set', '')
        return <div className={`mrl-set ${parseInt(setNumber) === parseInt(_setNumber) ? 'set-a' : _setNumber}`}>
          <div className={setScore.away > setScore.home ? 'tsw' : ''}>{setScore?.away}</div>
          <div>-</div>
          <div className={setScore.home > setScore.away ? 'tsw' : ''}>{setScore?.home}</div>
        </div>
      })
      return sss
    }

    if (!_.isEmpty(currentSets)) {
      return <div className='match-rez-rt'>
        {div_match()}
        <div className={'mrl-sets'}> {div_sets(currentSets)}</div>
        <div className={'mrl-dn'}>{createInitials(displayName)}</div>
      </div>
    } else if (score) {
      return <div className='match-rez-md'>
        <div></div>
        {div_match()}
        <div className={'mrl-dn'}>{createInitials(displayName)}</div>
      </div>
    }

  }

  const scoreLines_realtime = useMemo(() => {
    if (!result_realtime) return;
    const _scoreLines_realtime = result_realtime && scoreLine(result_realtime)
    return _scoreLines_realtime
  }, [result_realtime])

  const scoreLines_matchDay = useMemo(() => {
    if (!result_matchDay) return;
    const _scoreLines_matchDay = result_matchDay && scoreLine(result_matchDay)
    return _scoreLines_matchDay
  }, [result_matchDay])

  return <>
    {scoreLines_realtime}
    {scoreLines_matchDay}
  </>

}

export default MatchRealtimeScores